import React from 'react';
import { EDITED_COMMENT_INDICATOR } from '../../../common/constants/data-hooks';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { st, classes } from './edited-comment-indicator.st.css';
export const EditedCommentIndicator = ({ onClick, className, onHover, disabled, }) => {
    const t = useTranslate();
    return (React.createElement("div", { "data-hook": EDITED_COMMENT_INDICATOR, className: st(classes.root, { isDisabled: disabled }, className), onClick: () => !disabled && onClick(), onMouseEnter: () => !disabled && onHover?.() }, t('comment.edited-indicator')));
};
//# sourceMappingURL=edited-comment-indicator.js.map